export default __webpack_public_path__ + "static/impact5-9cacf6e1c3b72cb42206d00d8e495760.png";